import Navbar from './Navbar'
import Hero from './Hero'
import Problem from './Problem'
import Features from './Features'
import HowItWorks from './HowItWorks'
import Pricing from './Pricing'
import Cta from './Cta'
import Faq from './Faq'
import Footer from './Footer'
import { ModalProvider } from './ModalContext'
import WaitlistModal from './WaitlistModal'

export default function LandingPage({ pagarmePublicKey }) {
  return (
    <ModalProvider pagarmePublicKey={pagarmePublicKey}>
      <main className="min-h-screen bg-surface-page w-full text-text-primary">
        <Navbar />
        <Hero />
        <Problem />
        <Features />
        <HowItWorks />
        <Pricing />
        <Cta />
        <Faq />
        <Footer />
      </main>
      <WaitlistModal />
    </ModalProvider>
  )
}
